/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const ActivityCard = styled.a`
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
  height: 340px;

  @media (min-width: ${fullConfig.theme.screens.md}) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media (min-width: ${fullConfig.theme.screens.lg}) {
    flex: 0 0 33.33%;
    max-width: 33.33%;
  }

  @media (min-width: ${fullConfig.theme.screens.xl}) {
    height: 600px;
  }
`;

const CountElem = styled.span.attrs(() => {
  const classNamesToAdd = ['text-secondary', 'pr-2'];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

export { ActivityCard, CountElem };
